import { useParams } from "react-router";

import { BasePage } from "components/BasePage/BasePage";
import { useProjectDetails } from "./Details/hooks/useProjectDetails";
import { TopLevelDirectiveResearch } from "components/DirectiveSearch/TopLevelDirectiveResearch";

interface TopLevelDirectiveSearchRouteParams {
  projectId: string;
}

const TopLevelDirectiveSearch = () => {
  const { projectId } = useParams<TopLevelDirectiveSearchRouteParams>();
  const { project } = useProjectDetails(projectId);

  return (
    <BasePage
      breadcrumbItems={[
        { label: "projects", location: "/dashboard" },
        {
          label: project?.projectdata?.product_name || projectId,
          location: `/projects/${projectId}`,
        },
        {
          label: "steps.questionaire.label",
          location: `/projects/${projectId}/questionaire`,
        },
      ]}
    >
      <TopLevelDirectiveResearch type={"ce"} />
    </BasePage>
  );
};

export default TopLevelDirectiveSearch;
